import { render, staticRenderFns } from "./CategorySave.vue?vue&type=template&id=3b9b87aa&"
import script from "./CategorySave.vue?vue&type=script&lang=js&"
export * from "./CategorySave.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports